import InteractiveExperience from "./InteractiveExperience";
import withData from "./connect";

export default withData(InteractiveExperience);
